import { render, staticRenderFns } from "./equipe.vue?vue&type=template&id=3b9f4833"
import script from "./equipe.vue?vue&type=script&lang=js"
export * from "./equipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports